const BULK_ACTION_BUTTONS = [
    { id: 'bulk-make-public', action: 'make_public' },
    { id: 'bulk-make-private', action: 'make_private' },
    { id: 'bulk-duplicate', action: 'duplicate' },
];

function ensureBulkState(instance) {
    if (!instance._bulkSelection) {
        instance._bulkSelection = new Set();
    }

    if (!instance._bulkUIHooks) {
        instance._bulkUIHooks = [];
    }
}

function registerTeardown(instance, fn) {
    instance._bulkUIHooks.push(fn);
}

export function initBulkActionsUI() {
    ensureBulkState(this);

    this.bulkUI = {
        bar: document.getElementById('bulk-actions'),
        selectionCount: document.getElementById('selection-count'),
        selectionTemplate: document.getElementById('selection-count')?.dataset?.countTemplate || '%d đã chọn',
        selectAll: document.getElementById('select-all-collections'),
        deleteModal: document.getElementById('bulk-delete-modal'),
        deleteCount: document.getElementById('bulk-delete-count'),
    };

    const selectAll = this.bulkUI.selectAll;
    if (selectAll) {
        const handler = (event) => this.toggleSelectAll(event.target.checked);
        selectAll.addEventListener('change', handler);
        registerTeardown(this, () => selectAll.removeEventListener('change', handler));
    }

    BULK_ACTION_BUTTONS.forEach(({ id, action }) => {
        const button = document.getElementById(id);
        if (!button) {
            return;
        }

        const handler = () => {
            if (this._bulkSelection.size === 0) {
                return;
            }

            this.handleBulkAction(action, Array.from(this._bulkSelection));
        };

        button.addEventListener('click', handler);
        registerTeardown(this, () => button.removeEventListener('click', handler));
    });

    const deleteButton = document.getElementById('bulk-delete');
    if (deleteButton) {
        const handler = () => this.openBulkDeleteModal();
        deleteButton.addEventListener('click', handler);
        registerTeardown(this, () => deleteButton.removeEventListener('click', handler));
    }

    const cancelDelete = document.getElementById('cancel-bulk-delete');
    if (cancelDelete) {
        const handler = () => this.closeBulkDeleteModal();
        cancelDelete.addEventListener('click', handler);
        registerTeardown(this, () => cancelDelete.removeEventListener('click', handler));
    }

    const confirmDelete = document.getElementById('confirm-bulk-delete');
    if (confirmDelete) {
        const handler = () => {
            this.closeBulkDeleteModal();
            if (this._bulkSelection.size === 0) {
                return;
            }
            this.handleBulkAction('delete', Array.from(this._bulkSelection));
        };
        confirmDelete.addEventListener('click', handler);
        registerTeardown(this, () => confirmDelete.removeEventListener('click', handler));
    }

    this.updateSelectionCount();
    this.updateBulkActionsVisibility();
    this.updateSelectAllCheckboxState();
}

export function refreshBulkSelectionBindings() {
    ensureBulkState(this);

    const checkboxes = document.querySelectorAll('.collection-checkbox');
    checkboxes.forEach((checkbox) => {
        const collectionId = checkbox.getAttribute('data-collection-id');
        checkbox.checked = this._bulkSelection.has(collectionId);

        if (checkbox.dataset.bulkSelectionBound === '1') {
            return;
        }

        checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
                this._bulkSelection.add(collectionId);
            } else {
                this._bulkSelection.delete(collectionId);
            }

            this.updateSelectionCount();
            this.updateBulkActionsVisibility();
            this.updateSelectAllCheckboxState();
        });

        checkbox.dataset.bulkSelectionBound = '1';
    });

    this.updateSelectionCount();
    this.updateBulkActionsVisibility();
    this.updateSelectAllCheckboxState();
}

export function clearBulkSelection() {
    if (!this._bulkSelection) {
        return;
    }

    this._bulkSelection.clear();

    document.querySelectorAll('.collection-checkbox').forEach((checkbox) => {
        checkbox.checked = false;
    });

    this.updateSelectionCount();
    this.updateBulkActionsVisibility();
    this.updateSelectAllCheckboxState();
}

export function toggleSelectAll(shouldCheck) {
    ensureBulkState(this);

    const checkboxes = document.querySelectorAll('.collection-checkbox');
    if (checkboxes.length === 0) {
        return;
    }

    checkboxes.forEach((checkbox) => {
        checkbox.checked = shouldCheck;
        const collectionId = checkbox.getAttribute('data-collection-id');

        if (shouldCheck) {
            this._bulkSelection.add(collectionId);
        } else {
            this._bulkSelection.delete(collectionId);
        }
    });

    this.updateSelectionCount();
    this.updateBulkActionsVisibility();
    this.updateSelectAllCheckboxState();
}

export function updateSelectionCount() {
    const label = this.bulkUI?.selectionCount;
    if (!label) {
        return;
    }

    const template = this.bulkUI.selectionTemplate || '%d đã chọn';
    const text = template.replace('%d', this._bulkSelection.size.toString());
    label.textContent = text;
}

export function updateBulkActionsVisibility() {
    const bar = this.bulkUI?.bar;
    if (!bar) {
        return;
    }

    if (this._bulkSelection.size > 0) {
        bar.classList.remove('hidden');
    } else {
        bar.classList.add('hidden');
    }
}

export function updateSelectAllCheckboxState() {
    const selectAll = this.bulkUI?.selectAll;
    if (!selectAll) {
        return;
    }

    const checkboxes = document.querySelectorAll('.collection-checkbox');
    const total = checkboxes.length;
    const selected = this._bulkSelection.size;

    if (total === 0 || selected === 0) {
        selectAll.checked = false;
        selectAll.indeterminate = false;
        return;
    }

    if (selected === total) {
        selectAll.checked = true;
        selectAll.indeterminate = false;
    } else {
        selectAll.checked = false;
        selectAll.indeterminate = true;
    }
}

export function openBulkDeleteModal() {
    if (!this.bulkUI?.deleteModal) {
        return;
    }

    if (this._bulkSelection.size === 0) {
        return;
    }

    if (this.bulkUI.deleteCount) {
        this.bulkUI.deleteCount.textContent = this._bulkSelection.size;
    }

    this.bulkUI.deleteModal.classList.remove('hidden');
    this.bulkUI.deleteModal.classList.add('flex');
}

export function closeBulkDeleteModal() {
    if (!this.bulkUI?.deleteModal) {
        return;
    }

    this.bulkUI.deleteModal.classList.add('hidden');
    this.bulkUI.deleteModal.classList.remove('flex');
}

export function teardownBulkActionsUI() {
    if (!this._bulkUIHooks) {
        return;
    }

    this._bulkUIHooks.forEach((fn) => fn());
    this._bulkUIHooks = [];
    this._bulkSelection = new Set();
}
